import React from 'react';
import { SEO } from '../components/seo/SEO';
import { useLanguage } from '../context/LanguageContext';
import { ProductLandingPage } from '../components/content/ProductLandingPage';

export const OfficerShieldPage: React.FC = () => {
  const { language } = useLanguage();

  const content = {
    de: {
      seo: {
        title: 'Enterprise Governance & Digital Resilience – DORA/NIS2 Framework',
        description: 'Ganzheitliches GRC-Framework mit auditfähigen Policies und Reporting.',
      },
      hero: {
        eyebrow: 'Enterprise Governance',
        title: 'Digital Resilience & GRC Framework',
        subtitle:
          'Governance, Risk & Compliance als strategische Grundlage für DACH-Enterprises.',
        cta: { label: 'GRC-Assessment anfragen', href: '/consultation' },
      },
      problem: {
        title: 'Strategischer Bedarf',
        items: [
          'NIS2 und DORA verlangen institutionalisierte Kontrollen.',
          'Register, Third-Party-Risk und Incident-Prozesse müssen standardisiert sein.',
          'Einkauf und Revision benötigen auditfähige Nachweise.',
          'Regulatorisches Reporting muss skalierbar und konsistent sein.',
        ],
      },
      solution: {
        title: 'Unser Framework',
        items: [
          {
            title: 'Living Register (RoI)',
            desc: 'Automatische Zuordnung von Cloud- und On-Prem-Assets zu GRC-Standards.',
          },
          {
            title: 'Regulatory Reporting',
            desc: 'Standardisierte Reports und Meldepakete für Aufsichtsbehörden.',
          },
          {
            title: 'Policy & Evidence Library',
            desc: 'Auditfähige Policies, Kontrollen und Nachweispfade.',
          },
        ],
      },
      steps: {
        title: 'Engagement-Modell',
        items: [
          { title: 'Assess', desc: 'Bestandsaufnahme von Kontrollen, Assets und Risiken.' },
          { title: 'Design', desc: 'GRC-Framework und Reporting-Prozesse definieren.' },
          { title: 'Operationalize', desc: 'Governance, Reporting und Evidenz in Betrieb bringen.' },
        ],
      },
      cta: {
        title: 'Stärken Sie Governance und Resilienz',
        subtitle: 'Wir liefern das Framework für Compliance, Audit und Executive Reporting.',
        button: { label: 'GRC-Assessment anfragen', href: '/consultation' },
      },
    },
    en: {
      seo: {
        title: 'Enterprise Governance & Digital Resilience – DORA/NIS2 Framework',
        description: 'Holistic GRC framework with audit-ready policies and reporting.',
      },
      hero: {
        eyebrow: 'Enterprise Governance',
        title: 'Digital resilience & GRC framework',
        subtitle:
          'Governance, risk & compliance as a strategic foundation for DACH enterprises.',
        cta: { label: 'Request GRC assessment', href: '/consultation' },
      },
      problem: {
        title: 'Strategic context',
        items: [
          'NIS2 and DORA demand institutionalized controls.',
          'Registers, third-party risk, and incident processes must be standardized.',
          'Procurement and audit require evidence-ready documentation.',
          'Regulatory reporting must be scalable and consistent.',
        ],
      },
      solution: {
        title: 'Our framework',
        items: [
          {
            title: 'Living Register (RoI)',
            desc: 'Automated mapping of cloud and on-prem assets to GRC standards.',
          },
          {
            title: 'Regulatory reporting',
            desc: 'Standardized reporting packs for regulators and auditors.',
          },
          {
            title: 'Policy & evidence library',
            desc: 'Audit-ready policies, controls, and evidence trails.',
          },
        ],
      },
      steps: {
        title: 'Engagement model',
        items: [
          { title: 'Assess', desc: 'Baseline controls, assets, and risks.' },
          { title: 'Design', desc: 'Define GRC framework and reporting processes.' },
          { title: 'Operationalize', desc: 'Run governance, reporting, and evidence operations.' },
        ],
      },
      cta: {
        title: 'Strengthen governance and resilience',
        subtitle: 'We deliver the framework for compliance, audit, and executive reporting.',
        button: { label: 'Request GRC assessment', href: '/consultation' },
      },
    },
  }[language];

  return (
    <>
      <SEO title={content.seo.title} description={content.seo.description} />
      <ProductLandingPage content={content} />
    </>
  );
};

export default OfficerShieldPage;
